<template>
  <div> 
    <DataTable 
      :value="fieldsToShow" 
      :reorderableColumns="true"  
      @row-reorder="onRowReorder"
      :selection.sync="selectedFilter"
      selectionMode="single"
      editMode="cell"
      class="editable-cells-table" 
      responsiveLayout="scroll"
    >
      <Column :rowReorder="true" header="Order" headerStyle="width: 3rem" :reorderableColumn="false" />
      <Column 
        field="fieldName" 
        header="Filter Name"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          {{ slotProps.data.favouriteName || slotProps.data.filterName }}
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import FiltersService from "../../../service/FiltersSerice";

export default {
  created() {
    this.setupComponent()
  },
  props: {
    favourites: {
      type: Array,
      required: true
    },
    reloadComponent: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    filtersService: new FiltersService(),
    fieldsToShow: [],
    selectedFilter: null
  }),
  watch: {
    selectedFilter(val) {
      if (val && val.id) {
        let a = val
        this.selectedFilter = {}
        this.$emit('selected', a)
      }
    },
    reloadComponent() {
      this.setupComponent()
    }
  },
  methods: {
    setupComponent() {
      
      

      this.fieldsToShow = this.favourites
    },
    onRowReorder(event) {
      // 
      if (event.value) {
        this.fieldsToShow = event.value

        let orderDetails = []
        this.fieldsToShow.forEach((a, index) => {
          orderDetails.push({
            id: a.id,
            favourite: a.favourite,
            favouriteOrder: index + 1
          })
        })
        
        
        this.filtersService
          .updateFavOrder({
            filters: orderDetails
          })
          .then(data => {
            
            
            this.$store.dispatch('commons/favoriteFilters', this.fieldsToShow)
          })
          .catch(error => {
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "updateFavOrder/{orderDetails}"'
            })
          })
      }
    }
  }
}
</script>

<style>

</style>